import { EMPTY_GUID } from "@shared/tools/constants/constants";

export class ChantMediaModel {
  id: string =EMPTY_GUID;
  chantEsperanceId: number =0;
  path: string ='';
  pathUrl: string ='';
  contentType: string ='';
  size: string ='';
  artistName: string ='';
  extention: string ='';

  genreName: string ='';
  duree: string ='';
  typeFile: string ='';

  audioPathUrl: string ='';
  diagrammeNotePathUrl: string ='';

  isInstrumental: boolean =false;
  isDefault: boolean =false;
  dateCreated: string ='';
  dateModif: string ='';
}

export class ChantAudioModel extends ChantMediaModel {
}
export class ChantDiagrammeNoteModel extends ChantMediaModel {
}

export enum ChantMediaTextField {
  title='Chant/Lyric',
  title1='Chant/Lyric',
  position='#track',
  titre ='title' ,
  artistName ='artist Name' ,
  genreName ='genre Name' ,
  descriptions ='descriptions' ,
  isInstrumental ='is Instrumental' ,
}
